import { ACTOR_TYPES } from '@savgroup-front-common/constants/shared';

export const DEFAULT_ENTITY_TYPE: ACTOR_TYPES = ACTOR_TYPES.SELLER;

export const USER_MANAGEMENT_KEY = 'userManagement';
